jQuery(document).ready(function(){
    $('.collections-list li').click(function(){
      var listID = $(this).attr('id');
  
      $('.collections-list li').removeClass('active');
      $('.colection_content').removeClass('active');
  
      $(this).addClass('active');
  
      $('.colection_content').each(function(){
        if($(this).attr('id') === listID){
          $(this).addClass('active');
        }
      });
    });
  
$('.service_slides').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  pauseOnHover: false,
  arrows: false,
  infinite: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

  
  
    $('.custom-prev').click(function () {
    $('.service_slides').slick('slickPrev');
  });
  
  $('.custom-next').click(function () {
    $('.service_slides').slick('slickNext');
  });
  
  
  
  
  
      $('.review_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 600,
        arrows: false, // Hide default arrows
        dots: false,
        infinite: true,
        responsive: [
            {
              breakpoint: 580,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false, // Hide default arrows
                dots: true,
              }
            }
          ]
      });
  
     $('.review-prev').click(function () {
      $('.review_slider').slick('slickPrev');
    });

    $('.review-next').click(function () {
      $('.review_slider').slick('slickNext');
    });
  
    });
  
  
  

  
  